module.exports = __webpack_public_path__ + "static/media/aboutLower.41757efc.jpg";